/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_09bbf46b"]'><cube-button bolder>粗体文字</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_09bbf46b"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_09bbf46b"}
  /** script content **/
  require("./btn-bolder.mpx.js?isComponent&outputPath=components%2Fbtn-bolder09bbf46b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-bolder.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-bolder09bbf46b%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_09bbf46b"],
    ctorType: "component",
    outputPath: "components/btn-bolder09bbf46b/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>